if (!customElements.get('esc-testimonial-rotator')) {
  class EscTestimonialRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.esc-testimonial__slide'));
      if (this.slides.length < 2) return;

      this.index = this.slides.findIndex((s) => s.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;
      this.intervalMs = (parseInt(this.dataset.interval, 10) || 6) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      // theme editor: show the block an admin selects, resume on deselect
      this.onBlockSelect = (event) => {
        const i = this.slides.indexOf(event.target);
        if (i >= 0) {
          this.stop();
          this.show(i);
        }
      };
      this.onBlockDeselect = (event) => {
        if (this.slides.includes(event.target)) this.start();
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    show(i) {
      this.slides.forEach((slide, idx) => {
        slide.classList.toggle('is-active', idx === i);
        if (idx === i) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      this.index = i;
    }

    next() {
      this.show((this.index + 1) % this.slides.length);
    }

    start() {
      if (this.reducedMotion.matches) return;
      this.stop();
      this.timer = setInterval(() => this.next(), this.intervalMs);
    }

    stop() {
      clearInterval(this.timer);
    }
  }

  customElements.define('esc-testimonial-rotator', EscTestimonialRotator);
}
